(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  /* Swaps the grid for the pills in blocks/_blog-filters.liquid rather than reloading, so
     the reader keeps their scroll position. Without it they are still ordinary links. */
  (() => {
    const PILL = 'a.blog-filters__pill';
    const section = () => document.querySelector('[data-blog-grid]');
    const route = (url) => new URL(url, window.location.href).pathname.replace(/\/$/, '');

    let request = null;
    let rendered = route(window.location.href);

    const syncPills = (url) => {
      document.querySelectorAll('.blog-filters[data-blog-filters-root]').forEach((nav) => {
        nav.querySelectorAll(PILL).forEach((pill) => {
          const own = pill.dataset.blogFilterUrl;
          if (!own) return;

          const active = route(own) === route(url);
          pill.classList.toggle('blog-filters__pill--active', active);
          pill.href = active ? nav.dataset.blogFiltersRoot : own;

          if (active) {
            pill.setAttribute('aria-current', 'page');
          } else {
            pill.removeAttribute('aria-current');
          }
        });
      });
    };

    const render = async (url, push) => {
      const root = section();
      const inner = root && root.querySelector('.blog__inner');
      if (!inner) return;

      const endpoint = new URL(url, window.location.href);
      endpoint.searchParams.set('section_id', root.dataset.blogGrid);

      const controller = new AbortController();
      if (request) request.abort();
      request = controller;

      root.classList.add('blog--loading');
      inner.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(endpoint, { signal: controller.signal });
        if (!response.ok) throw new Error(response.status);

        const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = markup.querySelector('.blog__inner');
        if (!next) throw new Error('no grid in response');

        inner.innerHTML = next.innerHTML;
        rendered = route(url);
        syncPills(url);
        if (push) window.history.pushState({ blogFilter: url }, '', url);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.href = url;
      } finally {
        if (request === controller) {
          request = null;
          root.classList.remove('blog--loading');
          inner.removeAttribute('aria-busy');
        }
      }
    };

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const pill = event.target instanceof Element ? event.target.closest(PILL) : null;
      if (!pill || !pill.dataset.blogFilterUrl || !section()) return;

      event.preventDefault();
      render(pill.href, true);
    });

    /* Same-document history only, so a back out of the blog is still the browser's. */
    window.addEventListener('popstate', () => {
      if (!section() || route(window.location.href) === rendered) return;
      render(window.location.href, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /* Everything the platform treats as focusable. Used to drive Tab inside the panel
     rather than leaving it to the UA: a Section Rendering swap replaces the control the
     keyboard was on, which drops focus onto `<body>`, and from there the UA's own cycle
     has nothing inside the dialog to advance from. Safari compounds it — with its
     default "Tab highlights text fields and lists only", every button in the panel is
     skipped outright. Either way the close button was the one stop a keyboard reached. */
  const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'summary',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]',
  ].join(',');

  /* `tabIndex >= 0` drops anything deliberately taken out of the order — the row's media
     link, which is aria-hidden because the title block already links to the same product,
     and a carousel's offscreen clones. The rect test drops what is rendered but not on
     screen, such as the editor's hidden cart state. */
  const isTabbable = (el) =>
    el.tabIndex >= 0 &&
    !el.closest('[aria-hidden="true"]') &&
    (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0);

  /* How a row control is named across a re-render. Ordered most specific first, and the
     stepper values are spelled out so `+` is not restored as `−`. */
  const FOCUS_HOOKS = [
    '[data-cart-qty-step="-1"]',
    '[data-cart-qty-step="1"]',
    '[data-cart-qty-input]',
    '[data-cart-remove]',
    '[data-cart-drawer-close]',
  ];

  class CartDrawer extends HTMLElement {
    // Survives the element: Shopify rebuilds the section on every settings change, and
    // this is how the panel knows to come back open. Editor-only.
    static editorOpen = false;

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.returnFocus = null;

      // Delegated, so a Section Rendering swap of `innerHTML` never has to rebind.
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.addEventListener('close', this.onDialogClose.bind(this), true);
      // `cancel` is Esc, and it fires before `close`. Cancelling it in the editor keeps
      // the panel up — Esc there is usually aimed at a settings field, not the drawer.
      this.addEventListener('cancel', (event) => {
        if (this.designMode) event.preventDefault();
      });

      // The header's cart button is a plain link to /cart and stays that way — it is
      // the no-JS fallback. Intercepted here so the header does not have to know the
      // drawer exists.
      this.onHeaderClick = this.onHeaderClick.bind(this);
      document.addEventListener('click', this.onHeaderClick);

      this.onCartUpdated = this.onCartUpdated.bind(this);
      document.addEventListener('cart:updated', this.onCartUpdated);

      // Theme editor: the panel is the thing being edited, so it follows selection
      // rather than the shopper's clicks.
      if (this.designMode) {
        this.onEditorSelect = this.onEditorSelect.bind(this);
        this.onEditorDeselect = this.onEditorDeselect.bind(this);
        document.addEventListener('shopify:section:select', this.onEditorSelect);
        document.addEventListener('shopify:block:select', this.onEditorSelect);
        document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
        document.addEventListener('shopify:block:deselect', this.onEditorDeselect);

        // Editing a setting makes Shopify re-render the section, which destroys this
        // element and builds a new one. The static flag is what survives that, so the
        // panel comes back open instead of vanishing on every keystroke.
        if (CartDrawer.editorOpen) this.open();
      }

    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onHeaderClick);
      document.removeEventListener('cart:updated', this.onCartUpdated);
      if (this.designMode) {
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:block:select', this.onEditorSelect);
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        document.removeEventListener('shopify:block:deselect', this.onEditorDeselect);
      }
    }

    get designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    // Two directions to test. `shopify:section:select` targets the section, which
    // CONTAINS this element; `shopify:block:select` targets the block, which this
    // element contains. Testing only one way closes the panel the moment a block
    // inside it is selected.
    onEditorSelect(event) {
      const target = event.target;
      const section = target.contains(this);
      const block = this.contains(target);
      if (!section && !block) {
        this.close();
        return;
      }
      this.open();
      // A block selection also decides which state is on screen; selecting the whole
      // section drops back to whichever matches the real cart.
      this.setEditing(block ? target : null);
    }

    onEditorDeselect(event) {
      // Only a section-level deselect closes. A block deselect is followed by another
      // block's select, and closing in between would flash the panel shut.
      if (event.target.contains(this)) {
        this.setEditing(null);
        this.close();
      }
    }

    setEditing(target) {
      if (target && target.closest('[data-cart-drawer-empty]')) this.dataset.editing = 'empty';
      else if (target && target.closest('[data-cart-drawer-form]')) this.dataset.editing = 'rows';
      else if (target && target.closest('[data-cart-drawer-extras]')) this.dataset.editing = 'extras';
      else delete this.dataset.editing;
    }

    get dialog() {
      return this.querySelector('[data-cart-drawer-dialog]');
    }

    /* ---- Open / close ------------------------------------------------- */

    open(trigger) {
      const dialog = this.dialog;
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
      if (trigger) this.returnFocus = trigger;
      dialog.showModal();
      this.setTriggerState(true);
      if (this.designMode) CartDrawer.editorOpen = true;
      // Stealing focus in the editor pulls the merchant out of the settings field they
      // are typing in, so only a shopper gets sent to the close button.
      if (!this.designMode) this.querySelector('[data-cart-drawer-close]')?.focus();
      // A closed `<dialog>` measures a zero-width track, so any carousel inside it —
      // the upsell row — can only test its overflow once the panel is up.
      requestAnimationFrame(() => window.themeCarousel?.refresh(this));
    }

    close() {
      if (this.designMode) CartDrawer.editorOpen = false;
      if (this.dialog?.open) this.dialog.close();
    }

    // Every trigger, not just the one that was clicked — the drawer also opens on an
    // add to cart, with no trigger at all.
    setTriggerState(expanded) {
      document
        .querySelectorAll('[data-cart-drawer-open], [data-header-cart]')
        .forEach((trigger) => trigger.setAttribute('aria-expanded', String(expanded)));
    }

    onHeaderClick(event) {
      const trigger = event.target.closest?.('[data-header-cart], [data-cart-drawer-open]');
      if (!trigger) return;
      // Let a modified click open /cart in its own tab, as any link would.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      if (typeof this.dialog?.showModal !== 'function') return;
      event.preventDefault();
      this.open(trigger);
    }

    onDialogClose() {
      this.setTriggerState(false);
      const target = this.returnFocus;
      this.returnFocus = null;
      if (target && document.contains(target)) target.focus();
    }

    /* ---- Keyboard ------------------------------------------------------ */

    // Every control inside the panel, in DOM order: promo links, then each row's stepper,
    // quantity and remove, then the merchant blocks, then checkout.
    focusables() {
      const dialog = this.dialog;
      if (!dialog) return [];
      return Array.from(dialog.querySelectorAll(FOCUSABLE)).filter(isTabbable);
    }

    onKeydown(event) {
      if (event.key !== 'Tab') return;
      if (!this.dialog?.open) return;

      const items = this.focusables();
      if (items.length === 0) return;

      // No match means focus is on the dialog or was stranded on `<body>` by a swap, so
      // both directions re-enter the panel from an end rather than going nowhere.
      const current = items.indexOf(document.activeElement);
      const last = items.length - 1;
      const next = event.shiftKey
        ? items[current <= 0 ? last : current - 1]
        : items[current === -1 || current === last ? 0 : current + 1];

      event.preventDefault();
      next.focus();
    }

    /* ---- Focus across a re-render -------------------------------------- */

    // Names the control the keyboard is on in terms that survive the swap: its own data
    // hook, plus the line key of the row holding it. The row's position is kept too, so
    // a control on a row that has just been removed lands on whichever row took its
    // place instead of throwing the shopper back to the close button.
    focusMark() {
      const active = document.activeElement;
      if (!active || !this.contains(active)) return null;

      const hook = FOCUS_HOOKS.find((selector) => active.closest(selector));
      if (!hook) return null;

      const row = active.closest('[data-cart-row]');
      if (!row) return { hook, lineKey: '', index: -1 };

      const rows = Array.from(this.querySelectorAll('[data-cart-row]'));
      return { hook, lineKey: row.dataset.lineKey || '', index: rows.indexOf(row) };
    }

    restoreFocus(mark) {
      const close = this.querySelector('[data-cart-drawer-close]');
      if (!mark) {
        close?.focus();
        return;
      }

      let target = null;
      if (mark.index < 0) {
        target = this.querySelector(mark.hook);
      } else {
        const rows = Array.from(this.querySelectorAll('[data-cart-row]'));
        const row =
          rows.find((candidate) => candidate.dataset.lineKey === mark.lineKey) ||
          rows[Math.min(mark.index, rows.length - 1)];
        target = row?.querySelector(mark.hook) || null;
      }

      (target || close)?.focus();
    }

    /* ---- Line item controls ------------------------------------------- */

    onClick(event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        this.close();
        return;
      }

      // A backdrop click targets the dialog element itself. Ignored in the editor —
      // clicking the panel's own padding is not a request to dismiss what you are
      // editing, and selection already governs whether it is open.
      if (event.target === this.dialog) {
        if (!this.designMode) this.close();
        return;
      }

      const step = event.target.closest('[data-cart-qty-step]');
      if (step) {
        event.preventDefault();
        this.stepQuantity(step);
        return;
      }

      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        this.writeLine(remove.closest('[data-cart-row]'), 0);
      }
    }

    onChange(event) {
      const input = event.target.closest('[data-cart-qty-input]');
      if (!input) return;
      const row = input.closest('[data-cart-row]');
      this.writeLine(row, this.clamp(input, parseInt(input.value, 10)));
    }

    // With JS the form is never posted: the change/click handlers have already written
    // every edit. Reached only by implicit submission, so re-apply and swallow it.
    onSubmit(event) {
      if (!event.target.matches('[data-cart-drawer-form]')) return;
      event.preventDefault();
      const input = this.querySelector('[data-cart-qty-input]:focus');
      if (!input) return;
      this.writeLine(input.closest('[data-cart-row]'), this.clamp(input, parseInt(input.value, 10)));
    }

    // 0 is the remove value and always allowed; anything above it is held between the
    // variant's own min and max.
    clamp(input, value) {
      if (!Number.isFinite(value) || value < 0) return 1;
      if (value === 0) return 0;
      const min = parseInt(input.dataset.min, 10) || 1;
      const max = parseInt(input.getAttribute('max'), 10);
      if (value < min) return min;
      if (Number.isFinite(max) && value > max) return max;
      return value;
    }

    stepQuantity(button) {
      const row = button.closest('[data-cart-row]');
      // A frozen row is out of reach for a pointer, but `pointer-events: none` does
      // nothing to Enter or Space — so the keyboard could queue a second write.
      if (!row || row.hasAttribute('data-cart-busy')) return;
      const input = row.querySelector('[data-cart-qty-input]');
      if (!input) return;
      const delta = parseInt(button.dataset.cartQtyStep, 10) || 0;
      const next = this.clamp(input, (parseInt(input.value, 10) || 0) + delta);
      input.value = next;
      this.writeLine(row, next);
    }

    writeLine(row, quantity) {
      if (!row || !window.themeCart || row.hasAttribute('data-cart-busy')) return;
      const key = row.dataset.lineKey;
      const line = parseInt(row.dataset.line, 10);
      // Freeze the row so a second tap cannot race the write; the re-render replaces it.
      row.setAttribute('data-cart-busy', '');

      // A collapsed row stands for several cart lines, so the total is spread across them
      // in one write — CN filled first, VN given up first. `allocate` returns null for an
      // ordinary row, which takes the single-line path.
      const updates = window.themeCart.allocate(row.dataset.groupLines, quantity);
      const written = updates
        ? window.themeCart.update(updates, 'cart-drawer')
        : window.themeCart.change({ id: key || undefined, line: key ? undefined : line, quantity }, 'cart-drawer');

      written.catch(() => row.removeAttribute('data-cart-busy'));
    }

    /* ---- Re-render ----------------------------------------------------- */

    onCartUpdated(event) {
      const source = event.detail?.source;
      const shouldOpen =
        this.dataset.openOnAdd === 'true' && source !== 'cart-drawer' && event.detail?.itemCount > 0;
      this.render().then(() => {
        if (shouldOpen) this.open();
      });
    }

    render() {
      if (!this.sectionId) return Promise.resolve();
      // App-proxy paths (/apps/wishlist) are not theme pages, so Section Rendering
      // misses there. The storefront root always is — and is the one URL the
      // Accept-header note below says is unaffected.
      const path = window.location.pathname;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const page = /\/apps\//.test(path) ? root : path;
      const url = `${page}?sections=${encodeURIComponent(this.sectionId)}`;
      // No `Accept: application/json`. Shopify content-negotiates that header on
      // /products, /collections and /cart and answers with the resource's own JSON
      // instead of the sections, so the swap below finds nothing and the cart goes stale.
      return fetch(url, { cache: 'no-store' })
        .then((response) => (response.ok ? response.json() : Promise.reject(response)))
        .then((data) => {
          const markup = data[this.sectionId];
          if (!markup) return;
          const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('cart-drawer');
          if (!next) return;

          const dialog = this.dialog;
          const nextDialog = next.querySelector('[data-cart-drawer-dialog]');
          const wasOpen = !!dialog?.open;
          const scroll = this.querySelector('[data-cart-drawer-body]')?.scrollTop || 0;
          const hadFocus = this.contains(document.activeElement);
          // Read before the swap: the element it names is about to be replaced.
          const focusMark = hadFocus ? this.focusMark() : null;

          // Swap what is inside the panel, never the panel itself: replacing the
          // `<dialog>` closes it, and re-opening replays `@starting-style`, so every
          // edit reads as the drawer sliding shut and back in.
          if (wasOpen && nextDialog) {
            dialog.innerHTML = nextDialog.innerHTML;
          } else {
            this.innerHTML = next.innerHTML;
            // Only reached open if the response carried no panel to graft in.
            if (wasOpen) this.dialog?.showModal();
          }

          this.dataset.itemCount = next.dataset.itemCount;
          // Picks which of the two states CSS shows. Left stale, removing the last line
          // hides the empty state and leaves the panel blank.
          this.dataset.cartState = next.dataset.cartState;

          const body = this.querySelector('[data-cart-drawer-body]');
          if (body) body.scrollTop = scroll;
          if (wasOpen) {
            // Back onto the same control, not the close button: a keyboard shopper
            // stepping a quantity would otherwise be returned to the top of the panel on
            // every press.
            if (hadFocus) this.restoreFocus(focusMark);
            // The swap replaced the row with unmounted markup.
            requestAnimationFrame(() => window.themeCarousel?.refresh(this));
          }
        })
        .catch(() => {
          /* leave the current markup in place — the next write will try again */
        });
    }

  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onCartUpdated = this.onCartUpdated.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }

    onClick(event) {
      const step = event.target.closest('[data-cart-qty-step]');
      if (step) {
        event.preventDefault();
        this.stepQuantity(step);
        return;
      }

      // Intercepted only when there is a cart layer to write through; without one the
      // anchor's own href still removes the line.
      const remove = event.target.closest('[data-cart-remove]');
      if (remove && window.themeCart) {
        event.preventDefault();
        this.writeLine(remove.closest('[data-cart-row]'), 0);
      }
    }

    onChange(event) {
      const input = event.target.closest('[data-cart-qty-input]');
      if (!input) return;
      this.writeLine(input.closest('[data-cart-row]'), this.clamp(input, parseInt(input.value, 10)));
    }

    // 0 is the remove value and always allowed; anything above it is held between the
    // variant's own min and max.
    clamp(input, value) {
      if (!Number.isFinite(value) || value < 0) return 1;
      if (value === 0) return 0;
      const min = parseInt(input.dataset.min, 10) || 1;
      const max = parseInt(input.getAttribute('max'), 10);
      if (value < min) return min;
      if (Number.isFinite(max) && value > max) return max;
      return value;
    }

    stepQuantity(button) {
      const row = button.closest('[data-cart-row]');
      const input = row?.querySelector('[data-cart-qty-input]');
      if (!input) return;
      const delta = parseInt(button.dataset.cartQtyStep, 10) || 0;
      const next = this.clamp(input, (parseInt(input.value, 10) || 0) + delta);
      input.value = next;
      this.writeLine(row, next);
    }

    writeLine(row, quantity) {
      if (!row || !window.themeCart) return;
      const key = row.dataset.lineKey;
      const line = parseInt(row.dataset.line, 10);
      // Freeze the row so a second tap cannot race the write; the re-render replaces it.
      row.setAttribute('data-cart-busy', '');

      // A collapsed row stands for several cart lines, so the total is spread across them
      // in one write — CN filled first, VN given up first. `allocate` returns null for an
      // ordinary row, which takes the single-line path.
      const updates = window.themeCart.allocate(row.dataset.groupLines, quantity);
      const written = updates
        ? window.themeCart.update(updates, 'cart-page')
        : window.themeCart.change({ id: key || undefined, line: key ? undefined : line, quantity }, 'cart-page');

      written.catch(() => row.removeAttribute('data-cart-busy'));
    }

    onCartUpdated() {
      this.render();
    }

    render() {
      if (!this.sectionId) return Promise.resolve();
      const url = `${window.location.pathname}?sections=${encodeURIComponent(this.sectionId)}`;
      // No `Accept: application/json`. Shopify content-negotiates that header on /cart
      // and answers with the cart's own JSON instead of the sections, so the swap below
      // would find nothing and the page would go stale.
      return fetch(url, { cache: 'no-store' })
        .then((response) => (response.ok ? response.json() : Promise.reject(response)))
        .then((data) => {
          const markup = data[this.sectionId];
          if (!markup) return;
          const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('cart-page');
          if (!next) return;

          const focused = document.activeElement;
          const hadFocus = this.contains(focused);

          this.innerHTML = next.innerHTML;
          this.dataset.itemCount = next.dataset.itemCount;

          if (hadFocus) this.querySelector('[data-cart-qty-input]')?.focus();
          // The swap replaced the row with unmounted markup.
          requestAnimationFrame(() => window.themeCarousel?.refresh(this));
        })
        .catch(() => {
          /* leave the current markup in place — the next write will try again */
        });
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    constructor() {
      super();
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.tilesInline = window.matchMedia('(min-width: 1024px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.inner = this.querySelector('.header__inner');
      this.bar = this.querySelector('.header__bar');
      this.toggle = this.querySelector('[data-header-toggle]');
      this.nav = this.querySelector('.header__nav');
      this.backdrop = this.querySelector('[data-header-backdrop]');
      this.navItems = Array.from(this.querySelectorAll('[data-nav-item]'));

      this.lastScrollY = 0;
      this.ticking = false;
      this.closeTimer = null;
      this.openTimer = null;
      this.pendingItem = null;
      this.pendingOpen = false;
      this.hoverOpenDelay = 350;

      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.lastScrollY = window.scrollY;
      this.syncTopState();
      this.refreshLogo();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('pointerleave', this.onPointerLeave);
      this.desktop.addEventListener('change', this.onBreakpointChange);

      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.toggleMobileMenu());
      }
      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => {
          this.closeMobileMenu();
          this.closeAllItems();
        });
      }
      // Each top-level item with a panel: click toggles (works on desktop and
      // mobile, keyboard-friendly); hover opens on desktop only.
      this.navItems.forEach((item) => {
        const toggle = item.querySelector('[data-nav-toggle]');
        toggle?.addEventListener('click', () => {
          if (item.hasAttribute('data-open')) this.closeItem(item);
          else this.openItem(item);
        });

        // The panel is a child of the item, so this only fires once the pointer
        // has left both the link and its dropdown — collapse the bar then.
        item.addEventListener('pointerleave', () => {
          if (this.desktop.matches) this.scheduleClose();
        });
      });

      // Delegated hover: pointerover keeps firing as the cursor moves, so the
      // gaps between links can't strand a panel open. Items without a panel
      // close whatever is open so the dropdown never lingers behind them.
      this.nav?.addEventListener('pointerover', (event) => {
        if (!this.desktop.matches) return;
        const item = event.target.closest('.header__nav-item');
        if (!item) return;
        if (item.hasAttribute('data-nav-item')) this.scheduleOpen(item);
        else {
          this.cancelScheduledOpen();
          this.closeAllItems();
        }
      });

      // Mobile drill-down + close-on-navigate (desktop uses the hover/click above).
      this.nav?.addEventListener('click', (event) => {
        if (this.desktop.matches) return;

        // "Back" returns the open panel to page 1.
        const back = event.target.closest('[data-nav-back]');
        if (back) {
          const parent = back.closest('[data-nav-item]');
          if (parent) this.closeItem(parent);
          return;
        }

        // Tap a Tier 1 row (outside its panel) to drill in rather than navigate.
        const item = event.target.closest('[data-nav-item]');
        if (item && !event.target.closest('[data-nav-panel]') && !item.hasAttribute('data-open')) {
          event.preventDefault();
          this.openItem(item);
          if (this.nav) this.nav.scrollTop = 0;
          return;
        }

        // Any other link (Tier 2/3, secondary menu, Shop all) navigates — close up.
        if (event.target.closest('a')) this.closeMobileMenu();
      });

      this.initCarousels();

      // Live cart count updates from other components that dispatch cart events.
      document.addEventListener('cart:updated', (event) => this.updateCartCount(event));
      document.addEventListener('cart:refresh', (event) => this.updateCartCount(event));
    }

    /* ---- Ad carousel progress (mobile) -------------------------------- */

    initCarousels() {
      this.querySelectorAll('[data-header-carousel]').forEach((track) => {
        const progress = track.parentElement?.querySelector('.header__mega-tiles-progress');
        const bar = progress?.querySelector('[data-carousel-progress]');
        if (!bar) return;
        track.refreshProgress = () => {
          const max = track.scrollWidth - track.clientWidth;
          if (max <= 1) {
            progress.hidden = true;
            return;
          }
          progress.hidden = false;
          const rate = Math.min(Math.max(Math.abs(track.scrollLeft) / max, 0), 1);
          bar.style.width = `${rate * 100}%`;
        };
        let ticking = false;
        track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
              track.refreshProgress();
              ticking = false;
            });
          },
          { passive: true }
        );
        track.refreshProgress();
      });
    }

    // The panels are display:none until open, so measure once they're laid out.
    refreshCarousels(scope) {
      (scope || this).querySelectorAll('[data-header-carousel]').forEach((track) => {
        window.requestAnimationFrame(() => {
          this.fitTiles(track);
          track.refreshProgress?.();
        });
      });
    }

    /* ---- Tile fit (desktop) ------------------------------------------- */

    // Hides, in reverse editor order, the tiles whose design width does not fit in the
    // room the columns leave. Design widths rather than measured ones: the tiles can
    // shrink, so a measured row always "fits" and the first tile is what gets crushed.
    fitTiles(track) {
      const tiles = Array.from(track.querySelectorAll(':scope > .mega-tile'));
      tiles.forEach((tile) => tile.removeAttribute('data-tile-overflow'));
      if (!this.tilesInline.matches || tiles.length < 2) return;

      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.columnGap) || 0;
      const available =
        track.clientWidth - (parseFloat(style.paddingInlineStart) || 0) - (parseFloat(style.paddingInlineEnd) || 0);

      let used = 0;
      tiles.forEach((tile, index) => {
        const width = tile.getAttribute('data-mega-tile-size') === 'large' ? 417 : 316;
        const next = used + width + (index > 0 ? gap : 0);
        if (next > available && index > 0) {
          tile.setAttribute('data-tile-overflow', '');
          return;
        }
        used = next;
      });
    }

    onResize() {
      if (this.resizeTicking) return;
      this.resizeTicking = true;
      window.requestAnimationFrame(() => {
        const open = this.querySelector('[data-nav-item][data-open]');
        if (open) this.refreshCarousels(open);
        this.resizeTicking = false;
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.desktop.removeEventListener('change', this.onBreakpointChange);
    }

    /* ---- Scroll: hide on down, reveal (secondary logo) on up ---------- */

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
    }

    handleScroll() {
      const currentY = window.scrollY;
      const atTop = currentY <= 8;
      const delta = currentY - this.lastScrollY;
      const moved = Math.abs(delta) > 4;

      this.syncTopState(atTop);

      // A dropdown shouldn't survive a scroll, and leaving one open would other-
      // wise block the hide/reveal below.
      if (!atTop) this.closeAllItems();

      if (atTop) {
        this.setHidden(false);
      } else if (moved && this.getAttribute('data-menu-open') !== 'true') {
        // Scrolling down hides the header; scrolling back up reveals it.
        if (delta > 0 && currentY > 80) this.setHidden(true);
        else if (delta < 0) this.setHidden(false);
      }

      this.refreshLogo();

      if (atTop || moved) this.lastScrollY = currentY;
    }

    syncTopState(atTop) {
      const isTop = atTop ?? window.scrollY <= 8;
      this.setAttribute('data-at-top', String(isTop));
    }

    setHidden(hidden) {
      if (hidden) this.setAttribute('data-hidden', 'true');
      else this.removeAttribute('data-hidden');
    }

    // Primary logo at the top of the page; secondary once scrolled away or when
    // the mega menu is expanded (both put the logo on a solid bar). Which primary
    // artwork shows — light or dark — is not decided here: a solid template ships
    // only the dark one, and an overlay template picks between them in CSS from the
    // tone the section under the bar declares.
    refreshLogo() {
      const secondary =
        this.hasAttribute('data-expanded') ||
        this.getAttribute('data-menu-open') === 'true' ||
        this.getAttribute('data-at-top') !== 'true';
      this.setAttribute('data-logo', secondary ? 'secondary' : 'primary');
    }

    /* ---- Mega menu ----------------------------------------------------- */

    openItem(target) {
      window.clearTimeout(this.closeTimer);
      this.cancelScheduledOpen();
      if (target.hasAttribute('data-open')) return;
      this.navItems.forEach((item) => {
        const open = item === target;
        item.toggleAttribute('data-open', open);
        item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', String(open));
      });
      this.syncExpandedState();
      this.refreshCarousels(target);
    }

    closeItem(target) {
      target.removeAttribute('data-open');
      target.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', 'false');
      this.syncExpandedState();
    }

    closeAllItems() {
      if (!this.navItems.some((item) => item.hasAttribute('data-open'))) return;
      this.navItems.forEach((item) => {
        item.removeAttribute('data-open');
        item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      this.syncExpandedState();
    }

    syncExpandedState() {
      const anyOpen = this.navItems.some((item) => item.hasAttribute('data-open'));
      // Only the desktop dropdown drives the full-width "expanded" chrome.
      if (anyOpen && this.desktop.matches) this.setAttribute('data-expanded', 'true');
      else this.removeAttribute('data-expanded');
      this.refreshLogo();
    }

    // Hover intent: wait before opening the first panel so a mouse passing over
    // the nav doesn't fire it. With a panel already open, switch instantly.
    scheduleOpen(target) {
      if (this.navItems.some((item) => item.hasAttribute('data-open'))) {
        this.openItem(target);
        return;
      }
      if (this.pendingItem === target) return;
      window.clearTimeout(this.openTimer);
      this.pendingItem = target;
      this.openTimer = window.setTimeout(() => this.openItem(target), this.hoverOpenDelay);
    }

    cancelScheduledOpen() {
      window.clearTimeout(this.openTimer);
      this.pendingItem = null;
    }

    // Small delay so crossing the gap between a link and its panel doesn't close it.
    scheduleClose() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.closeAllItems(), 260);
    }

    onPointerLeave() {
      if (!this.desktop.matches) return;
      this.cancelScheduledOpen();
      this.scheduleClose();
    }

    onFocusOut(event) {
      if (!this.desktop.matches) return;
      if (!this.contains(event.relatedTarget)) this.closeAllItems();
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const openItem = this.navItems.find((item) => item.hasAttribute('data-open'));
      if (this.getAttribute('data-menu-open') === 'true') {
        // On mobile, Escape steps back out of a drill-down first, then closes.
        if (openItem) {
          this.closeItem(openItem);
        } else {
          this.closeMobileMenu();
          this.toggle?.focus();
        }
      } else if (openItem) {
        this.closeItem(openItem);
        openItem.querySelector('[data-nav-toggle]')?.focus();
      }
    }

    /* ---- Mobile off-canvas menu --------------------------------------- */

    toggleMobileMenu() {
      if (this.getAttribute('data-menu-open') === 'true' || this.pendingOpen) this.closeMobileMenu();
      else this.openMobileMenu();
    }

    openMobileMenu() {
      this.setHidden(false);
      // Tapped while the bar is still sliding back in: wait for the slide. Until the
      // section's transform is gone it contains the fixed drawer and backdrop, and
      // the bar edge measured below would be mid-flight.
      const slide = this.slideInProgress();
      if (slide) {
        this.pendingOpen = true;
        const resume = () => {
          if (this.pendingOpen) this.openMobileMenu();
        };
        slide.finished.then(resume, resume);
        return;
      }
      this.pendingOpen = false;
      this.setAttribute('data-menu-open', 'true');
      // Dock the drawer to the bar's bottom edge. The bar doesn't move between
      // states, so the drawer stays connected to it through the close fade.
      const bottom = (this.bar || this.inner)?.getBoundingClientRect().bottom;
      if (typeof bottom === 'number') {
        this.style.setProperty('--header-menu-top', `${Math.max(0, Math.round(bottom))}px`);
      }
      this.toggle?.setAttribute('aria-expanded', 'true');
      this.toggle?.setAttribute('aria-label', this.toggle.dataset.labelClose || 'Close menu');
      this.refreshLogo();
      document.body.style.overflow = 'hidden';
    }

    // The hide/reveal transition on the sticky section, while it is running.
    slideInProgress() {
      const section = this.closest('.shopify-section');
      if (!section || window.getComputedStyle(section).transform === 'none') return null;
      return section.getAnimations().find((animation) => animation.transitionProperty === 'transform') || null;
    }

    closeMobileMenu() {
      this.pendingOpen = false;
      this.removeAttribute('data-menu-open');
      this.toggle?.setAttribute('aria-expanded', 'false');
      this.toggle?.setAttribute('aria-label', this.toggle.dataset.labelOpen || 'Open menu');
      document.body.style.overflow = '';
      // Reset any open drill-down so the menu reopens on page 1.
      this.closeAllItems();
      this.refreshLogo();
    }

    onBreakpointChange() {
      this.closeMobileMenu();
      this.closeAllItems();
    }

    /* ---- Cart count ---------------------------------------------------- */

    updateCartCount(event) {
      const count = event?.detail?.itemCount ?? event?.detail?.item_count;
      if (typeof count !== 'number') return;
      const badge = this.querySelector('[data-cart-count]');
      const text = this.querySelector('[data-cart-count-text]');
      if (badge) {
        badge.textContent = count;
        badge.classList.toggle('is-empty', count === 0);
      }
      if (text) text.textContent = `${count}`;
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-header-banner"] && !Shopify.designMode) return;
  try {
    
  class PreHeaderBanner extends HTMLElement {
    constructor() {
      super();
      this.messages = Array.from(this.querySelectorAll('[data-message]'));
      this.index = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.shouldAutoplay =
        this.dataset.autoplay === 'true' && this.messages.length > 1 && !this.reducedMotion;
    }

    connectedCallback() {
      // Respect a prior dismissal for this browsing session.
      if (this.dataset.dismissible === 'true' && this.isDismissed()) {
        this.hide();
        return;
      }

      this.showMessage(0);
      this.bindEvents();

      if (this.shouldAutoplay) {
        this.play();
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    get storageKey() {
      return 'pre-header-banner-dismissed:' + this.id;
    }

    isDismissed() {
      try {
        return window.sessionStorage.getItem(this.storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-action]');
        if (!trigger) return;

        const action = trigger.dataset.action;
        if (action === 'next') this.next(true);
        else if (action === 'prev') this.prev(true);
        else if (action === 'dismiss') this.dismiss();
        else if (action === 'toggle-play') this.togglePlay(trigger);
      });

      // Escape dismisses when focus is inside the banner (keyboard-accessible).
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.dataset.dismissible === 'true') {
          this.dismiss();
        }
      });

      if (this.dataset.pauseOnHover === 'true') {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => {
          if (this.shouldAutoplay && !this.paused) this.play();
        });
      }

      // Pause rotation while a control has focus so keyboard users aren't rushed.
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => {
        if (this.shouldAutoplay && !this.paused && !this.contains(document.activeElement)) {
          this.play();
        }
      });
    }

    showMessage(nextIndex) {
      if (!this.messages.length) return;
      this.messages[this.index].removeAttribute('data-active');
      this.index = (nextIndex + this.messages.length) % this.messages.length;
      this.messages[this.index].setAttribute('data-active', '');
    }

    next(userInitiated) {
      this.showMessage(this.index + 1);
      if (userInitiated) this.restart();
    }

    prev(userInitiated) {
      this.showMessage(this.index - 1);
      if (userInitiated) this.restart();
    }

    play() {
      this.stop();
      if (this.messages.length < 2) return;
      this.timer = window.setInterval(() => this.next(false), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      if (this.shouldAutoplay && !this.paused) this.play();
    }

    togglePlay(button) {
      this.paused = !this.paused;
      if (this.paused) {
        this.stop();
      } else {
        this.play();
      }
      button.setAttribute('aria-pressed', String(this.paused));
      const pauseIcon = button.querySelector('.pre-header-banner__icon-pause');
      const playIcon = button.querySelector('.pre-header-banner__icon-play');
      if (pauseIcon && playIcon) {
        pauseIcon.hidden = this.paused;
        playIcon.hidden = !this.paused;
      }
    }

    dismiss() {
      this.stop();
      try {
        window.sessionStorage.setItem(this.storageKey, '1');
      } catch (e) {
        /* storage unavailable — dismiss for this pageview only */
      }
      this.hide();
    }

    hide() {
      this.setAttribute('hidden', '');
    }
  }

  if (!customElements.get('pre-header-banner')) {
    customElements.define('pre-header-banner', PreHeaderBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-block"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const clearPin = (wrap) => {
      wrap.classList.remove('text-block-pin');
      wrap.style.removeProperty('background-color');
    };

    const setupPins = () => {
      const blocks = document.querySelectorAll('[data-text-block-animate]');
      const enablePin = !motionQuery.matches;

      blocks.forEach((block) => {
        const wrap = block.closest('.shopify-section');
        if (!wrap) return;

        clearPin(wrap);
        if (!enablePin) return;

        wrap.classList.add('text-block-pin');
        wrap.style.backgroundColor = getComputedStyle(block).backgroundColor;
      });
    };

    const setupReveal = (block) => {
      const content = block.querySelector('[data-text-block-content]');
      if (!content) return;

      if (block._textBlockObserver) {
        block._textBlockObserver.disconnect();
        block._textBlockObserver = null;
      }

      if (motionQuery.matches) {
        block.classList.remove('is-js-ready');
        content.classList.remove('is-visible');
        return;
      }

      block.classList.add('is-js-ready');

      if (content.classList.contains('is-visible')) return;

      if (!('IntersectionObserver' in window)) {
        content.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            content.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -10% 0px',
        }
      );

      block._textBlockObserver = observer;
      observer.observe(content);
    };

    const init = () => {
      document.querySelectorAll('[data-text-block-animate]').forEach(setupReveal);
      setupPins();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
    document.addEventListener('shopify:section:unload', () => {
      requestAnimationFrame(init);
    });

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', init);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(init);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
